module.exports = __webpack_public_path__ + "img/record-icon.a6a9f667.png";